export const COUNTRY_NAME_TO_ISO: Record<string, string> = {
    Italy: "IT",
    Germany: "DE",
    France: "FR",
    Spain: "ES",
    "United States": "US",
    "United Kingdom": "GB",
    India: "IN",
    // Add others as needed
};
